/* Tanvika — theme behaviours */

(function () {
  'use strict';

  // Toggle the frosted-glass pill header once the page has scrolled even
  // slightly. Threshold is deliberately small (8px) so it triggers on any
  // scroll rather than after clearing the whole header.
  function headerScroll() {
    var THRESHOLD = 8;
    var body = document.body;
    var ticking = false;

    function apply() {
      body.classList.toggle('tv-header-scrolled', window.pageYOffset > THRESHOLD);
      ticking = false;
    }

    apply();
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', headerScroll, { once: true });
  } else {
    headerScroll();
  }
})();
